import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { OPEN_PAYMENTS_TAG_TYPE } from './constants';

export interface OpenPaymentCompany {
  id: string;
  name?: string;
  [key: string]: unknown;
}

export interface OpenPaymentsSuggestionsResponse {
  results?: OpenPaymentCompany[];
  [key: string]: unknown;
}

export const openPaymentsApi = createApi({
  reducerPath: 'openPaymentsApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [OPEN_PAYMENTS_TAG_TYPE],
  endpoints: (builder) => ({
    getOpenPaymentsSuggestionsV2: builder.query<
      OpenPaymentsSuggestionsResponse,
      { q: string }
    >({
      query: ({ q }) => ({
        url: 'v1/entities/open-payments-companies/',
        params: { q },
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetOpenPaymentsSuggestionsV2Query } = openPaymentsApi;
